






import { Component, Vue } from 'vue-property-decorator';
import ProjectSimpleEditComponent from '@/components/project-simple-edit.vue';

@Component({
  components: {
    ProjectSimpleEditComponent
  }
})
export default class ProjectDetailPage extends Vue {
  project = this.$store.state.projectSimple;

  created(): void {
    this.$store.dispatch('projectSimple/clearProject');
    this.$store.dispatch('lookup/getAvailableLookup', 6);
    this.$store.dispatch('lookup/getAvailableLookup', 2);
    this.$store.dispatch('lookup/getAvailableLookup', 14);
    this.$store.dispatch('lookup/getAvailableLookup', 15);
  }
}
